import { Partner } from '@bybeam/platform-types';
import Icon from '@platform-ui-common/components/Icon/index.js';
import Message from '@platform-ui-common/components/Message/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import { IdentityPaths } from '../Routes.js';

function getTenantConfig(partner: Partner) {
  const { externalId } = partner || {};
  return {
    basic: IdentityPaths.SIGNIN_BASIC,
    emailSent: IdentityPaths.EMAIL_SENT,
    signin: IdentityPaths.SIGNIN,
    title: 'Applicant sign in',
    roleRedirect: (
      <div className="flex flex-col gap-3 pt-3 pb-6">
        <Message variant="info">Are you reviewing cases?</Message>
        <Typography variant="body">
          The sign in page for case workers has moved <Icon type="arrowForward" size="SM" />{' '}
          <a
            className={
              'leading-none font-semibold uppercase gap-x-2 tracking-button inline-block text-center hover:underline'
            }
            href={`/partner/${externalId}`}
          >
            Sign In to review cases
          </a>
        </Typography>
      </div>
    ),
  };
}

export { getTenantConfig };
